/** Uygulama durumu. Yakalanan fotoğraflar yalnızca hafızada tutulur (diske/sunucuya
 * yazılmaz) — yükleme ADIM 3'ün işi.
 * ADIM 2 (2026-09-04): 3-slot ağız içi fotoğraf yükleme akışına göre yeniden şekillendirildi. */
import { PHOTO_STEPS, type PhotoSlotId } from "./config";

export type SlotStatus = "empty" | "checking" | "ok" | "blurry" | "dark" | "unreadable";

export interface SlotState {
  id: PhotoSlotId;
  /** İşlenmiş (EXIF-orientation düzeltilmiş, downscale edilmiş, EXIF/GPS'siz
   * yeniden kodlanmış) JPEG — YÜKLENEN artefakt budur. Orijinal `File`
   * BİLEREK tutulmuyor: state'te bir alanı olmayan veri, yanlışlıkla
   * yüklenemez (revizyoncu bulgusu, 2026-09-04, P0 — önceki tur orijinal
   * `File`'ı da tutuyordu, upload.ts onu göndermeye başlayabilirdi). */
  blob: Blob | null;
  previewUrl: string | null;
  sharpness: number | null;
  luma: number | null;
  status: SlotStatus;
  /** Kullanıcı bir kez uyarıldı ve yine de aynı sorunlu kareyi kullanmayı seçtiyse true.
   * Kalite kapısı sert kilit değildir — bkz. plan §3. */
  forcedOk: boolean;
  /** ADIM 3: Worker'a başarıyla yüklendikten sonra dönen R2 anahtarı (`<lead_id>/<slot>.jpg`).
   * Yükleme öncesi null — bu alan asla ham görüntü verisi taşımaz, yalnızca referans. */
  r2Key: string | null;
}

export interface AppState {
  consentGiven: boolean;
  slots: SlotState[];
}

export function createEmptySlots(): SlotState[] {
  return PHOTO_STEPS.map((step) => ({
    id: step.id,
    blob: null,
    previewUrl: null,
    sharpness: null,
    luma: null,
    status: "empty",
    forcedOk: false,
    r2Key: null,
  }));
}

export const state: AppState = {
  consentGiven: false,
  slots: createEmptySlots(),
};

export function getSlot(id: PhotoSlotId): SlotState {
  const slot = state.slots.find((s) => s.id === id);
  if (!slot) throw new Error(`Bilinmeyen slot: ${id}`);
  return slot;
}

export function allSlotsReady(): boolean {
  // blob !== null şartı kritik: "unreadable" (decode hatası) durumunda blob
  // yok, forcedOk true olsa bile yüklenecek bir şey yoktur — slot hazır
  // sayılamaz (revizyoncu P0 takibi, 2026-09-04).
  return state.slots.every((s) => s.blob !== null && (s.status === "ok" || s.forcedOk));
}
